module.exports = __webpack_public_path__ + "img/avatar-03-120x120.5f713284.png";